import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { HomeProblem } from '../components/home/HomeProblem';
import { HomeOfferings } from '../components/home/HomeOfferings';
import { HomePillars } from '../components/home/HomePillars';
import { HomeJudgmentFlow } from '../components/home/HomeJudgmentFlow';
import { HomeEcosystem } from '../components/home/HomeEcosystem';
import { HomeAudiences } from '../components/home/HomeAudiences';
import { HomeInitiatives } from '../components/home/HomeInitiatives';
import { HomeDemoCenter } from '../components/home/HomeDemoCenter';
import { HomeCTA } from '../components/home/HomeCTA';
export function HomePage() {
  return <>
      <HomeHero data-id="element-2917" data-mp="31zvigt033swd" />
      <HomeProblem data-id="element-2918" data-mp="31zby75myosf6" />
      <HomeOfferings data-id="element-2919" data-mp="31yttrlq5b7w6" />
      <HomePillars data-id="element-2920" data-mp="31yan515y45xg" />
      <HomeJudgmentFlow data-id="element-2921" data-mp="31xr6dns17nl0" />
      <HomeEcosystem data-id="element-2922" data-mp="2e9hkklutiztv" />
      <HomeDemoCenter data-id="element-2923" data-mp="2e8q2mdu590m2" />
      <HomeInitiatives data-id="element-2924" data-mp="2e86lgzcbig93" />
      <HomeAudiences data-id="element-2925" data-mp="29axzsorynu33" />
      <HomeCTA data-id="element-2926" data-mp="29bg6kfc91qp9" />
    </>;
}